import { createContext, useContext } from "react";
import { ConfigJson } from "../config-json.ts";

export const ConfigJsonContext = createContext<ConfigJson>({
  ENVIRONMENT_NAME: "dev",
  ACCERTIFY_ENDPOINT: "",
  API_ENDPOINT_WS: "",
});

export default function useConfigJson() {
  return useContext(ConfigJsonContext);
}
